import defaultHttpClient from "../httpClient/defaultHttpClient";
import homemadeClient from "../httpClient/homemadeClient";

const host = import.meta.env.VITE_APP_API_TAX;

const dataProviderRules = {
  // @ts-ignore
  ...homemadeClient(host, defaultHttpClient),
};

export default dataProviderRules;
